module.exports = __webpack_public_path__ + "img/ic_add_rounded.7e25a0c3.svg";